import {MuseOn} from "./MuseOn";

export class Structure extends MuseOn {
    name: string;
    image: string;
    logo: string;
    ticket: number;
    description: string;

    constructor (data) {
        super();

        this.name = data.name;
        this.image = data.image;
        this.logo = data.logo;
        this.ticket = data.ticket;
        this.description = data.description;
    }

    getObj(removeNull: boolean = false) {
        const result = {
            name : this.name || null,
            image : this.image || null,
            logo : this.logo || null,
            ticket : this.ticket || 0,
            description : this.description || null,
        };

        return removeNull
            ? this.removeNull(result)
            : result
            ;
    }
}
